import React from 'react';
import { IBarChart, ICog, IDownload, IShield, IUser, IUser3, IList, IPreferences, IPagesLight, IPlus} from './helixIcons';

export default function NavigationIcon(props: { type: string }) {
  switch (props.type) {
    case 'export':
      return <IDownload />;
    case 'insights':
      return <IBarChart />;
    case 'admin':
      return <ICog />;
    case 'sysadmin':
      return <IShield />;
    case 'account':
      return <IUser />;
    case 'project_members':
      return <IUser3 />;
    case 'project_templates':
      return <IPagesLight />;
    case 'project_lists':
      return <IList />;
    case 'project_settings':
      return <ICog />;
    case 'edit':
      return <ICog />;
    case 'more_options':
      return <IPreferences />;
    case 'create':
      return <IPlus />;
    default:
      return null;
  }
}
